"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../types");
var _program = require("@studio/program");
/**
 * This does not make an API call to update program on backend. Make use of
 * this when the expectation is to update program via the realtime
 * connector alone.
 * @param scene object the scene to set the program to
 */
function setProgramRealtime(scene) {
  return function (dispatch, getState) {
    var _getState = getState(),
      program = _getState.program;
    var action = {
      type: _types.BROADCAST_SET_PROGRAM,
      payload: (0, _program.applyAnimations)(program, scene)
    };
    dispatch(action);
  };
}
var _default = exports["default"] = setProgramRealtime;